/* eslint-disable quotes */
// Italiano
export const italiano = {
  start: "Cominciare ",
  configurations: "Impostazioni ",
  ramdom: "Modalità di gioco casuale",
  vibration: "Vibrazione ",
  startgame: "Cominciare il gioco",
  save: "Salvare",
  delete: "Eliminare",
  update: "Aggiornare",
  lets: "Giochiamo",
  permanentbuy: "Acquisto definitivo",
  signature: "Abbonamento mensile ",
  small: " Qui puoi usare il tuo vero nome... o un nick :)",
  text1: "Ottieni accesso Premium e garantisci tutti gli aggiornamenti ",
  text2:
    "Iscrivendoti potrai accedere alla versione Premium ogni volta che vorrai ",
  gender: "Genere",
  male: "Maschile ",
  female: "Femminile",
  ambos: "Entrambi",
  fechar: "Chiudere",
  sexualorientation: "Orientazione sessuale",
  heterosexual: "Eterosessuale",
  homosexual: "Omosessuale ",
  bisexual: "Bisessuale ",
  chooseavatar: "Scegli il tuo avatar",
  Participants: "Partecipanti",
  participant: "Iscrizione dei partecipanti",
  name: "Nome ",
  choosecategory: "Scegli le categorie",
  categories: "Categorie",
  light: "Leggero",
  preliminary: "Preliminari amorosi",
  oral: "Sesso orale",
  anal: "Sesso anale",
  hot: "Focoso",
  extreme: "Estremo",
  vd: "Verità",
  dare: "Sfide?",
  truth: "Verità",
  time: "Tempo",
  createMyChallenges: "Creare le mie sfide",
  chosen: "Selezionati",
  text3: "Lascia che l'amore scorra attraverso te!",
  text4: "Preparati per vivere intensamente",
  close: "Chiudere",
  sele: "Seleziona un'opzione",
  dev: "Sviluppato da Dev12BR",
  game: "Gioco",
  get: "Comprare - R$34,99",
  sign: "Abbonarsi - R$5,99",
  next: "PROSSIMO",
  config1: "Perché dovrei comprare la versione Premium?",
  config2: " 4 categorie esclusive e oltre 800 nuove sfide",
  config3: "Nessuna pubblicità",
  config4: "Scegli avatar da animare",
  config5: "Crea le tue sfide",
  config6: "Supporti lo sviluppo del gioco",
  config7: "Perché il gioco ha un prezzo?",
  config8:
    "Per sviluppare il gioco serve tempo! :) In questo modo sostieni il gioco, aiutaci a migliorare e ad aggiornare sempre il gioco.",
  config9: "Crea e modifica le tue sfide",
  age: `Questo gioco è riservato agli adulti, quindi devi avere almeno 18 anni. Selezionando "Sì", accetti i termini di utilizzo e la Privacy Policy.

     Questo gioco è adatto alle coppie, quindi devi giocare con almeno un compagno.
    
     Non è un'app di incontri, è un modo per giocare con il tuo partner.`,
  assessment:
    "Per favore, valutaci aggiungendo una recensione sull'app. Il tuo feedback è molto importante per noi al fine di far funzionare il gioco nel migliore modo possibile.",
  agree: "Sì, ho più di 18 anni",
  noAgree: "Chiudere l'applicazione",
  apoio1: "Supporta lo sviluppo sottoscrivendoti alla versione Premium :)",
  apoio2: "Non dimenticare di valutare l'app sull'Apple Store S2",
  apoio3: "Accedi a tutte le funzionalità esclusive della versione Premium ",
  apoio4: "Liberati di questo banner - Acquista la versione Premium",
  apoio5: "Non dimenticare di valutare l'applicazione su Google Play S2",
  version: "Versione Premium",
  version1: "Versione Premium",
  alert1: "Registra utenti per giocare ",
  alert2: "Registra almeno un utente in più per giocare",
  alert3: "Seleziona almeno una categoria",
  alert4: `🔥 Ci sono partecipanti senza partner. Abbi almeno due partecipanti per ciascun genere 🔞.
        
Es: due eterosessuali o due omosessuali.`,
  tituloAlert1: "⚠️ Il gioco sta per iniziare  😜",
  parser: "Nessun partner",
  premiumImages: "Diventa Premium e ottieni l'accesso a più avatar",
  duvidas: "Domande o suggerimenti - Sfide focosi",
  description: " Salve, la mia domanda o il mio suggerimento è:",
  send: "Inviare",
  contact: "Contatto",
  botaoApple: "Restaurare gli acquisti",
  alertCompra: "Il tuo acquisto è stato restaurato",
  NotPurchase: "Tu non hai nessun acquisto",
  notPurchase2:
    "Questo collegamento è solo per gli utenti che hanno acquistato in precedenza e desiderano restaurare su un nuovo dispositivo.",
  termOfPotitic: "Termini di utilizzo e Informativa sulla privacy",
  alertDeuErrado: "Qualcosa non ha funzionato :(",
  alertDeuErrado2: "Inserisci tutte le informazioni",
  alertNome: "Riempire il campo: Nome",
  options: "Opzioni",
  optionsTitle: "Opzioni",
  gradualGame: "Gioco graduale",
  textoCaixa:
    "Attivando questa selezione, le sfide saranno graduali, cioè dalla più leggera alla più estrema secondo la tua scelta. ",
  comoJogar: "Come giocare? 🤔",
  avalie: "Valuta",
  novaCategoria: "Le mie categorie",
  alterLanguage: "Cambiare lingua? ",
  textLanguage: "Quando si modifica la lingua, l'applicazione verrà riavviata",
  textLanguage1: "Cambiare lingua ",
  cancel: "Cancellare",
  languages: "Le lingue",
  email: "@email ✉️",
  deletCat: "Eliminare la categoria ",
  textDeletCat:
    "Cancellando questa categoria, le sfide ci presenti verranno cancellate. Dopo questa azione non è più possibile annullare.",
  deletDes: "Eliminare la sfida",
  textDeletDes:
    "Una volta eliminata la sfida, questa azione non può più essere annullata.",
  desafio: "Registrare una nuova sfida",
  desafiotexto: "Sfida",
  textoeditDesafio: "Chi può farlo? ",
  textEmquem: "Su chi?",
  nome: "Nome",
  inicio: "Cominciare il gioco",
  inicio2:
    "Premendo questo pulsante, verrai portato alla schermata di registrazione del giocatore 👥.",
  inicio3: "Il gioco inizierà presto 🎲",
  inicio4: "Prossimo",
  inicio5: "Regolazioni e impostazioni",
  inicio6: `Impostazioni come:
  
- Sfide graduale
- Cambia il linguaggio delle sfide
- Crea delle sfide
- Supporto
- Tra gli altri. `,
  inicio7: " Fine",
  inicio8: `Sii Premium e ottieni l'accesso a:

- Più di 450 nuove sfide 😎

- Personaggi esclusivi 🦸‍♀️ 🧑‍🚒

- Crea tu stesso le tue sfide 📝

- Mantieni aggiornato il gioco ✅

- E molto altro 😍`,
  inicio9: "Aiuto",
  inicio10: "Benvenuto nel gioco Sfide Focoso 🌶",
  inicio11:
    "Scopri quanto è facile giocare e navigare nei menu in meno di 30 secondi 😎.",
  inicio12: "Vedere il tutorial 👍🏼",
  inicio13: "Non voglio 👎🏼",
  inicio14: `Per cominciare il gioco, devi aggiungere almeno (2) due giocatori 😀
              
Premendo il tasto che viene indicato sopra 👆
  
Ogni volta che aggiungi un nuovo utente, premi lo stesso tasto 😘`,
  cadastrarCategory: "Registrare categoria",
  inicio15: "Creando di una nuova categoria ",
  inicio16:
    "Passaggio 1: premere il pulsante con il segno + che si trova nella parte inferiore di questa schermata. Dopo aver premuto, apparirà una finestra per accedere alla tua nuova categoria.",
  inicio17: "Passaggio 2: inserisci la nuova categoria e fai clic su salvare ",
  inicio18:
    "Passaggio 3: per modificare questa categoria o ci AGGIUNGERE SFIDE, fai clic su di essa. ",
  inicio19:
    "Passaggio 4: Nella schermata successiva, premendo il pulsante indicato con la freccia ⬆️, si aprirà una finestra per la modifica della tua nuova categoria.",
  inicio20:
    "Passaggio 5: Nella schermata successiva, premendo il pulsante indicato con la freccia ⬆️, eliminerai la categoria. ",
  inicio21:
    "Passaggio 1: premi il pulsante sottostante per aggiungere una nuova sfida a questa categoria",
  inicio22: "Creando una nuova sfida",
  inicio23:
    "Passaggio 2: fai clic su ogni elemento cerchiato per conoscere in dettaglio ogni campo di registrazione",
  inicio24: "Testo della sfida",
  inicio25: `Scrivi la sfida a tuo piacimento e, per visualizzare il nome del giocatore nella sfida, premi il pulsante rosso in basso.
    
Verranno aggiunti i seguenti caratteri {nome}.

** NON CAMBIARE QUESTI CARATTERI ** Per visualizzare il nome di conseguenza, deve essere come descritto di seguito ⬇️⬇️⬇️⬇️

Sfida: bacia il collo di {nome} `,
  inicio26: "Chi può fare e chi può ricevere",
  inicio27: `Seleziona "Entrambi" se la sfida può essere lanciata e ricevuta da partecipanti di "entrambi i generi".
  
Se la sfida è indirizzata a un genere, seleziona quello desiderato.`,
  inicio28: "Aggiungendo tempo alla sfida",
  inicio29:
    'Nel caso in cui la tua sfida abbia un tempo, trascina l\'"intervallo" in basso e il valore verrà visualizzato sopra. Dopo che il timer della sfida è scaduto, verrà riprodotto un suono che annuncia che la sfida è finita. ',
  aviso12: `Qui crei solamente la categoria!
    
Per aggiungere le sfide basta premere il pulsante della tua categoria che è stata appena creata ⬆️⬆️⬆️⬆️`,
  voltar: "Tornare indietro",
  semDe: "Giocatore senza sfide",
  semDe2: `Registra almeno una sfida per questo giocatore 😬.
  
Sarai reindirizzato alla schermata di login.`,
  term: "Privacy",
  Potitic: "Condizioni d'uso",
  adquirited: "Acquistato",
  config10: "Categorie esclusive",
  config11: "+ 800 nuove sfide",
  signatureano: "Assinatura Anual",
  camera: "Fotocamera",
  galery: "Galleria",
  avatar: "Avatar",
  image: "Immagine",
  seletion: " Selezionato",
  editCategory: "Modifica la categoria",
  frase1: "Ti piacciono le sfide?",
  frase2: "Che ne dici di provare le Sfide Premium ?",
  //err texto
  errTexto:
    "Se avete trovato un errore di traduzione, correggete la frase nel campo sottostante:",
  errTitulo: "Hai notato qualcosa di sbagliato?",
  errCorrect: "Come sarebbe in italiano?",
  thisLanguageIsCorrect: "La sfida in ITALIANO è corretta?",
  yes: "Sì",
  no: "No",
  errSend: "Invia un suggerimento",
  share: "Condividere",
  fraseShare: `Che applicazione top! Condivido solo perché so che piacerà anche a voi!
Scaricatelo e poi ditemi se non è troppo bello lol...😉
  
  
Link per il download: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇮🇹",

  morePlayer: "Giocare con più giocatori?",
  players: "Giocatori",
  carregar: "Carica immagine",
  takePhoto: "Scatta una foto o seleziona un'immagine",
  useAvatar: "Oppure utilizzare gli avatar",

  hetero: "Etero",
  gay: "Gay",
  lesbico: "Lesbica",

  nomeHomem1: "Nome dell'uomo",
  nomeHomem2: "Nome dell'uomo",
  nomeMulher1: "Nome della donna",
  nomeMulher2: "Nome della donna",
  messageErr: "Aggiungere i giocatori 🙌",
  descricaoErr: "Inserire i nomi dei partecipanti ✍️",
  why: "Ci dica perché...",
  later: "Valutare in seguito",
  txtCard1: "Tocca a te 🔥",
  txtCard2: "Fallo accadere 😘",
  txtCard3: "Forza! 😜",
  txtCard4: "Prossima sfida 😈",
  txtCard5: "Ancora una! 👄",

  tituloBloco1Novo: "Esplora l'intimità sessuale con il tuo partner",
  subtitulo1Novo: "Più di 1 milione di coppie felici",
  texto1Novo:
    "Scopri l'intimità tra te e il tuo partner e accedi ai migliori giochi per coppie! Sblocca ora tutti i giochi, suddivisi in categorie pensate per rafforzare la vostra connessione e rendere l'amore ancora più speciale!",
  tituloBloco2Novo: "Nuove esperienze per una relazione ancora più forte",
  texto2Novo1: "Goditi più di 1500 sfide uniche",
  texto2Novo2: "Crea le tue sfide personalizzate",
  texto2Novo3: "Categorie uniche ed esclusive",
  texto2Novo4: `Zero pubblicità per un'esperienza fluida`,
  texto2Novo5: "Avatar esclusivi e divertenti",
  texto2Novo6: "Sfide fresche ogni giorno",
  texto2Novo7: "Giochi sempre aggiornati e migliorati",
  tituloBloco3Novo: "La valutazione più alta nella sua categoria",
  tituloBloco4Novo: "I benefici per la tua relazione:",
  texto4Novo1: "Più intimità",
  texto4Novo2: "desiderio",
  texto4Novo3: "leggerezza",
  texto4Novo4: "Attrazione irresistibile",
  texto4Novo5: "Connessione profonda",
  texto4Novo6: "Piacere senza fine",

  tituloBloco5Novo: "Cosa dicono le coppie",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1:
    "Penso che questa sia la migliore app che ho trovato finora su mobile, sia erotica che interessante. Tutte le altre app che ho visto non possono competere, quindi trovatevi un lavoro e compratela. Non lamentatevi perché siete al verde. Vi state perdendo alcune cose davvero fantastiche qui, e con soli $10,00 potete possedere l'intera app. Offre esperienze migliori rispetto ai giochi che trovate nei negozi di piacere locali.",

  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "Questa app è incredibile! Ero indeciso se scaricarla o meno, ma è stata sicuramente la migliore esperienza che abbiamo avuto negli ultimi tempi. È fantastico sapere che possiamo ancora fare tante cose insieme. 🤭 Abbiamo provato la versione a pagamento ed è davvero valsa la pena, non avevamo mai raggiunto un livello di piacere simile.",

  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "Se vuoi ravvivare la relazione, questa app è perfetta! Avevo già provato altre app, ma nessuna ci ha soddisfatto come questa. I nostri preliminari sono stati molto più caldi e piacevoli (ora immaginate il resto!). Vale davvero la pena acquistare la versione a pagamento (se vuoi provare un piacere più intenso), ma anche la versione gratuita ci ha sorpreso.",

  texto5depoimentoTitulo4: "Anne Owens",
  texto5depoimento4:
    "Eccellente! Davvero molto buona... Ci siamo eccitati moltissimo durante il gioco, rendendo il sesso molto più coinvolgente, il piacere era ovunque! Non vediamo l'ora di giocare di nuovo 💦🔥. Consigliamo anche la versione a pagamento se riuscite a gestire tutta questa eccitazione 🤤.",
  tituloBloco6Novo:
    "Fate come centinaia di coppie in tutto il mondo e vivacizzare la vostra relazione. Scoprite più di 800 nuove sfide!",
  texto6Select: "Scegliere la versione:",
  texto6Premium: "Premium",
  texto6Assinatura: "Abbonamento",
  texto6Mensal: "mensile",
  texto6Anual: "annuale",
  texto6Vitalicia: "Licenza a vita",
  bePremium: "Diventa Premium",
  buyNew: "Acquista",
  attention: "Attenzione!",
  changeGender: "Avete cambiato il vostro orientamento sessuale.",

  tituloAvaliacao: "Ti sta piacendo il gioco?",
  textoAvaliacao: "Valutaci e aiutaci a migliorare!",
  agoraNão: "Non ora",
  enviarAvaliacao: "Invia",

  nomeJogo1: "Sfide Piccanti",
  nomeJogo2: "Obbligo o Verità ?!",
  nomeJogo3: "Livello di malizia",
  nomeJogo4: "Roulette Maliziosa ",
  nomeJogo5: "Frasi del Giorno",
  naughtyQuiz: "Quiz sulla cattiveria",

  playAlone: "Gioca da Solo",
  estaSozinho: "Sei da solo?",
  selectPlayer: "Seleziona il giocatore",

  skip: "Salta",
  responder: "Invia",
  respondaAqui: "Rispondi qui",
  config4: "Scegli avatar da personalizzare",

  tituloSelect1: "Gioca da solo?",
  tituloSelect2: "Rispondi a domande imbarazzanti!",

  subTituloSelect1: "Ti diamo una mano!",
  subTituloSelect2: "Scopri quanto sei birichino!",
  txtJogador1:
    "Seleziona il tuo giocatore ed esplora piaceri guidati pensati solo per te!",
  txtJogador2: "Il giocatore selezionato risponderà alle domande",
  tituloCena: "QUALI ELEMENTI VUOI USARE?",
  subTituloCena:
    "Non ne hai uno? Tocca 'Ottieni' e acquistalo nel negozio affiliato.",
  play: "Gioca",

  titleUserWarning: "Scegli un utente",
  txtUserWarning: "Scegli un utente per rispondere alle domande",

  shareNivelDeSafadeza:
    "Ehi, guarda il mio livello di sfrontatezza 😈 Sperimenta intensi momenti di piacere. Provalo anche tu 💋 Scarica l'app ora e preparati a goderti sfide piccanti 🔥 con il tuo partner!: ➡️ https://desafiospicantesapp.page.link/sharelevelhot",

  shareDica:
    "Trasforma la tua vita amorosa ora! Scarica l'app e scopri il segreto per una relazione piccante: ➡️ https://desafiospicantesapp.page.link/tipoftheday",

  resultadoQuiz1:
    "Sei una persona riservata, non ti piace molto la malizia, preferisci qualcosa di più romantico!",
  resultadoQuiz2: `Sei troppo romantico per abusare della malizia, e preferisci l'atmosfera delle candele.`,
  resultadoQuiz3:
    "Sei una persona piuttosto riservata e credi nel mantenere le cose più discrete e private nella vita intima.",
  resultadoQuiz4:
    "Questo non significa che non sei malizioso/a a volte, ma preferisci conservare tutto quel fuoco per condividerlo con qualcuno di davvero speciale.",
  resultadoQuiz5: `La tua passione è in secondo piano, ma questo non cambia il fatto che c'è calore!`,
  resultadoQuiz6:
    "Ti piace esplorare nuove esperienze, ma sempre nel rispetto e col consenso.",
  resultadoQuiz7: `Adori un incontro caldo, pieno di baci e coccole. Tuttavia, c'è un lato di te che ama anche guardare un film tenendo per mano il tuo/a ragazzo/a o cenare a lume di candela.`,
  resultadoQuiz8:
    "Sei disposto/a a provare cose nuove ed emozionanti, ma sempre con responsabilità.",
  resultadoQuiz9:
    "Sei una persona audace e ti piace rendere piccante la tua vita intima di tanto in tanto.",
  resultadoQuiz10:
    "Apprezzi tutti i piaceri della vita, e non hai limiti quando si tratta di sesso.",
  resultadoQuiz11:
    'Con te non esiste un momento sbagliato, e ogni momento è il momento giusto per una scappatella! Film romantico? Solo se si tratta di "Cinquanta sfumature di grigio"!',
  resultadoQuiz12: `Per te, l'intimità è un'avventura costante, e non hai paura di correre rischi.`,

  mes: "Mese",
  desafiosRestantesDois: "Hai 2 sfide Premium rimanenti!",
  nenhumDesafioRestante: "Non ci sono più sfide Premium disponibili!",
  tornePremiumAviso1: "Diventa premium ora e goditi 1000 sfide esclusive!",
  tornePremiumAviso2:
    "Goditi sfide senza limiti, contenuti esclusivi e un divertimento continuo!",
  conteudoPremium: "Hai selezionato un contenuto Premium!",
  aproveite4desafios:
    "Approfitta di 4 sfide premium per assaporare un piacere esclusivo.",

  calculando: "Calcolando i risultati...",
  nivelRomantismo: "Il tuo livello di romanticismo è...",
  finalizar: "Fine",
  erroQuizTitulo: "Inserisci la tua risposta",
  erroQuizFrase: "Per procedere, inserisci la tua risposta!",
  new: "Nuova app",

  //resposta quiz safadeza

  resQuiz1: "Gentile",
  resQuiz2: "Appassionato",
  resQuiz3: "Affascinante",
  resQuiz4: "Super birichino",

  texto6Semanal: "Settimanale",
  weekly: "Firma Settimanale",

  tempSemanal: "Addebitato settimanalmente",
  tempMensal: "Addebitato mensilmente",
  tempAnual: "Addebitato annualmente",
  tempSempre: "Pagamento unico",
  canceleAny: "Annulla in qualsiasi momento",

  //Tela do safadrometro
  Low: "Basso",
  Medium: "Medio",
  High: "Alto",
  lifeTime: "Accesso a vita",
  notNow: "Non adesso, grazie",

  match: "ABBINAMENTO CON A.I.",

  dateTitle: "Vuoi scoprire la nostra nuova app?",

  dateBody: `Vuoi chattare con bots birichini 😈 e praticare il tuo flirt? Ti divertirai!🔥`,
  goToDate: "Prova Date.AI ora!",
  goodForU: "È STATO BENE PER TE?",
  rateOurPerformance: "Valuta la nostra performance fino a questo punto",
  veryGood: "Molto Buono",
  veryBad: "Molto Cattivo",

  feedbackChallenge: `Cosa ti spingerebbe a condividere l'app Hot Challenges con altre coppie e perché?`,
  type: "Scrivi qui la tua risposta...",
  survey: "Indagine sulla soddisfazione.",
  shareIfConfortable: `Sentiti libero di condividere con gli amici se ti senti a tuo agio :)`,

  howToPlay: "Come giocare",
  howToPlayHotChallenge:
    "Preparati a rendere le cose più piccanti! Pesca una carta sfida e sorprendi il tuo partner con un’azione bollente!",

  preGameTip1:
    "Libera i tuoi desideri e crea momenti indimenticabili con il tuo partner!",
  preGameTip2:
    "Accendi le tue passioni e crea momenti indimenticabili insieme!",
  preGameTip3:
    "Esplora i tuoi desideri più selvaggi e crea ricordi indimenticabili!",
  preGameTip4: "Libera le tue fantasie e concediti momenti di puro piacere!",

  selecionajoagador: "È ora di giocare",
  dica: "Suggerimento",
  howToPlayNaughty:
    "Seleziona i tuoi giocattoli e oggetti preferiti. Gira la ruota e lascia che il destino decida la tua prossima sfida piccante!",
  howToPlayTruthOrDare:
    "Scegli il tuo destino: condividi una verità o accetta una sfida audace. Che il divertimento inizi!",
  howToKama1: "Scopri le Posizioni del Piacere – 365 Giorni di Passione!",
  howToKama2:
    "Scegli una carta a caso, prova la posizione ed esplora nuove vette di piacere insieme!",
  kamaExplain:
    "Sblocca una nuova posizione ogni giorno e costruisci la tua collezione definitiva di passione – il tuo viaggio di 365 giorni di piacere indimenticabile inizia qui!",
  howToDo: "Come fare",
  pergunta: "Domanda",
  restart: "Riavvia",
  dialogText1HotChallenges:
    "Hai completato tutte le sfide disponibili con le categorie selezionate.",
  dialogText2HotChallenges:
    "Seleziona altre categorie o riavvia il gioco con le sfide attuali!",
  noChallenges: "Nessuna Sfida!",

  objects: "Oggetti",
  dialogText1NaughtyGames:
    "Hai completato tutte le sfide disponibili con gli oggetti selezionati.",
  dialogText2NaughtyGames:
    "Seleziona più oggetti o riavvia il gioco con le sfide attuali!",
  unlockPremium: "Sblocca Premium",
  noCategory: "Per favore, scegli almeno una categoria per iniziare.",
  thanksForFeedback: "Grazie per aiutarci a migliorare l'esperienza!",
  categoryKamasutra: "Scegli la tua passione e gioca!",
  tap: "Tocca per rivelare la tua posizione!",
  step: "Guida Passo dopo Passo",

  shareQuizButton: "Condividi il tuo livello di malizia!",
  tryAgain: "Riprova",
  unlockAllFun: "Sblocca subito tutto il divertimento!",
  limitedOffer: "Offerta speciale a tempo limitato!",
  fill: "Inserisci il tuo nome e quello del tuo partner.",

  kamaNotificationTitle: "🔥 La tua nuova carta è sbloccata!",
  kamaNotificationBody:
    "La tua posizione del giorno {variavel} è pronta. Che ne dici di provare qualcosa di nuovo oggi? 💋",

  titleNewGame: "Preparati per il Roleplay!",
  phraseNewGame:
    "Nel prossimo aggiornamento, un nuovo gioco per esplorare le tue fantasie più creative sta arrivando. Scegli i personaggi, crea storie e porta il divertimento a un livello superiore con il tuo partner. 🔥",
  awaitNewGame: "Aspetta e preparati a vivere momenti unici!",

  selectObjects:
    "Seleziona due o più elementi per personalizzare il tuo gioco. Esplora al massimo.",
  soon: "Presto",
  wantToBeNotify: "Voglio essere avvisato",
  ok: "OK",
  vezDe: "GIRARE",

  categoryLabel: "Categoria",
  descriptionLabel: "Descrizione",

  loginConnect: "Accedi",
  loginNoAccount: "Non hai un account?",
  loginCreateNow: "Crea ora",
  loginOrConnect: "o connettiti con",

  email: "Email",
  password: "Password",
  loginRegister: "Registrati",
  loginAlreadyHas: "Hai già un account?",
  enterNow: "Accedi ora",

  logout: "Disconnettersi",
  customerPortal: "Portale Clienti",
  installApp: "Installa l'App",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/italiano.mp4",
};
